import React, { useState } from "react";

import BasicButton from "components/forms/BasicButton";
import { useToast } from "components/toast";
import { markProposalSent, setProposalOutcome } from "api/Proposals";

/**
 * Where a sent proposal ended up (2026-10-19): accepted (won) or lost, so
 * conversion can be measured. And, for a link nobody has recorded sending,
 * "I sent it" - the send that happened in someone's own email.
 */
const bar: React.CSSProperties = { display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap", padding: "10px 12px", border: "1px solid #E4E7EB", borderRadius: 8, margin: "10px 0", fontFamily: "Poppins", fontSize: 13 };
const input: React.CSSProperties = { border: "1px solid #E4E7EB", borderRadius: 6, padding: "6px 8px", fontFamily: "Poppins", fontSize: 12, minWidth: 220 };

const OutcomeBar: React.FC<{ proposal: any; onChanged: () => void }> = ({ proposal, onChanged }) => {
  const toast = useToast();
  const [busy, setBusy] = useState<string | null>(null);
  const [to, setTo] = useState("");

  const act = async (key: string, fn: () => Promise<any>, ok: string) => {
    setBusy(key);
    const res = await fn();
    setBusy(null);
    if (res?.error) return toast.add(res.error, "var(--theme-ui-colors-danger)");
    toast.add(ok, "var(--theme-ui-colors-success)");
    onChanged();
  };

  if (proposal.status === "won" || proposal.status === "lost") {
    const when = proposal.decidedAt ? new Date(proposal.decidedAt).toLocaleDateString() : "";
    return (
      <div style={{ ...bar, background: proposal.status === "won" ? "#E1F5EE" : "#FBEAEA" }}>
        <b>{proposal.status === "won" ? "Accepted" : "Lost"}</b>
        {when ? <span>{when}</span> : null}
        <span style={{ flex: 1 }} />
        <BasicButton outline scheme="secondary" type="button" keepText disabled={!!busy}
          onClick={() => act("flip", () => setProposalOutcome(proposal.id, proposal.status === "won" ? "lost" : "won"), "Updated.")}>
          {proposal.status === "won" ? "Mark lost instead" : "Mark accepted instead"}
        </BasicButton>
      </div>
    );
  }

  return (
    <div style={bar}>
      {!proposal.sentTo ? (
        <>
          <span>Sent the link yourself?</span>
          <input style={input} type="email" placeholder="who it went to" value={to} onChange={(e) => setTo(e.target.value)} />
          <BasicButton type="button" keepText disabled={!!busy || !to.trim()} onClick={() => act("sent", () => markProposalSent(proposal.id, to.trim()), "Send recorded.")}>
            {busy === "sent" ? "Saving…" : "Record the send"}
          </BasicButton>
          <span style={{ flex: 1 }} />
        </>
      ) : (
        <span style={{ flex: 1 }}>Outcome</span>
      )}
      <BasicButton type="button" keepText disabled={!!busy} onClick={() => act("won", () => setProposalOutcome(proposal.id, "won"), "Marked accepted.")}>Mark accepted</BasicButton>
      <BasicButton outline scheme="danger" type="button" keepText disabled={!!busy} onClick={() => act("lost", () => setProposalOutcome(proposal.id, "lost"), "Marked lost.")}>Mark lost</BasicButton>
    </div>
  );
};

export default OutcomeBar;
